import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../../core/services/auth.service';

export const authGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const router = inject(Router);
  const jwtHelper = inject(JwtHelperService);

  const token = localStorage.getItem('custm_token');

  if (!token) {
    return router.createUrlTree(['custm-login']);
  }

  const expirationDate = jwtHelper.getTokenExpirationDate(token);
  
  if (expirationDate) {
    const diffMinutes = (expirationDate.getTime() - Date.now()) / (1000 * 60);

    if (diffMinutes > 0) {
      return true;
    }
  }

  return router.createUrlTree(['custm-login']);
};